module.exports = __webpack_public_path__ + "media/beautiful-in-white.a78fb49f.mp3";